import {
	DropZoneArea,
	Dropzone,
	DropzoneMessage,
	DropzoneTrigger,
	useDropzone,
} from '@cocoonspace/ui/components/vercel/dropzone'
import { useLingui } from '@lingui/react/macro'
import { CloudUploadIcon } from 'lucide-react'

import { readFileAsDataURL } from './utils/read-file-as-data-url'

export const ImageDropzone = ({
	onChange,
}: {
	onChange: (value: string) => void
}) => {
	const { t } = useLingui()

	const dropzone = useDropzone({
		onDropFile: async (file) => {
			const imageDataUrl = await readFileAsDataURL(file)
			onChange(imageDataUrl)

			return {
				status: 'success',
				result: imageDataUrl,
			}
		},
		validation: {
			accept: {
				'image/*': ['.png', '.jpg', '.jpeg'],
			},
			maxSize: 10 * 1024 * 1024,
			maxFiles: 1,
		},
		shiftOnMaxFiles: true,
	})

	return (
		<Dropzone {...dropzone}>
			<div className='flex justify-between'>
				<DropzoneMessage />
			</div>

			<DropZoneArea>
				<DropzoneTrigger className='flex flex-col items-center gap-2 bg-transparent p-10 text-center text-sm'>
					<CloudUploadIcon className='!size-12' />

					<div className='flex flex-col items-center'>
						<p className='font-semibold'>{t`Uploader une photo`}</p>
						<p className='text-muted-foreground text-sm'>
							{t`Cliquez ici ou faites glisser et déposez pour télécharger`}
						</p>
					</div>
				</DropzoneTrigger>
			</DropZoneArea>
		</Dropzone>
	)
}
